export interface SelectOption {
  value: string;
  label: string;
}

const formatHourLabel = (hour: number): string => {
  const period = hour < 12 ? "AM" : "PM";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:00 ${period}`;
};

export const TIME_OPTIONS: SelectOption[] = Array.from(
  { length: 24 },
  (_, hour) => ({
    value: `${hour.toString().padStart(2, "0")}:00`,
    label: formatHourLabel(hour),
  }),
);

export const TIMEZONE_OPTIONS: SelectOption[] = Array.from(
  { length: 27 },
  (_, index) => {
    const offset = index - 12;
    const sign = offset >= 0 ? "+" : "-";
    const value = `GMT${sign}${Math.abs(offset)}:00`;
    return { value, label: value };
  },
);
